import { Injectable, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';

export const AUTH_BROADCAST_CHANNEL = 'continity_auth_channel';
export const AUTH_LOGOUT_STORAGE_KEY = 'continity_auth_logout';

export type AuthBroadcastMessage = { type: 'LOGOUT' };

@Injectable({ providedIn: 'root' })
export class AuthBroadcastService implements OnDestroy {
  private readonly logoutSubject = new Subject<void>();
  readonly logout$ = this.logoutSubject.asObservable();

  private channel: BroadcastChannel | null = null;

  constructor() {
    if (typeof BroadcastChannel !== 'undefined') {
      this.channel = new BroadcastChannel(AUTH_BROADCAST_CHANNEL);
      this.channel.onmessage = (event: MessageEvent<AuthBroadcastMessage>) => {
        if (event.data?.type === 'LOGOUT') this.logoutSubject.next();
      };
    }

    if (typeof window !== 'undefined') {
      window.addEventListener('storage', this.onStorage);
    }
  }

  broadcastLogout(): void {
    this.channel?.postMessage({ type: 'LOGOUT' } as AuthBroadcastMessage);
    try {
      localStorage.setItem(
        AUTH_LOGOUT_STORAGE_KEY,
        `${Date.now()}:${Math.random()}`
      );
    } catch {
      // BroadcastChannel remains the primary path when storage is unavailable.
    }
  }

  ngOnDestroy(): void {
    this.channel?.close();
    if (typeof window !== 'undefined') {
      window.removeEventListener('storage', this.onStorage);
    }
    this.logoutSubject.complete();
  }

  private readonly onStorage = (event: StorageEvent): void => {
    if (event.key === AUTH_LOGOUT_STORAGE_KEY) this.logoutSubject.next();
  };
}
